import { Controller } from "@hotwired/stimulus"
import Calendar from "mdb-calendar"

// MDB Calendar plugin
// When it is initially hidden or when turbo frame inserts it, we need to
// reinitialize. So, add this controller to the Calendar div. For example:
//
//    <div class="calendar mb-3" id="calendar" data-controller="mdb-calendar-init"></div>

export default class extends Controller {
  connect() {
    // Remove old calendar and initialize a new one
    this.cleanupAndInitializeCalendar()
  }

  cleanupAndInitializeCalendar = () => {
    // Destroy JS instance and remove any injected DOM
    this.element._mdbCalendarInstance?.destroy?.()
    this.element._mdbCalendarInstance = null

    // Remove all child nodes
    this.element.innerHTML = ""

    //Initialize a new Calendar
    this.element._mdbCalendarInstance = new Calendar(this.element)
  }
}
